export default __webpack_public_path__ + "static/media/trumpd.7e5680b1.png";